import { useState, useContext } from "react";
import { Modal } from "antd";
import { Info, X } from "lucide-react";
import { GuideContext } from "@/context/GuideContext";
import "./InfoModal.css";

const InfoModal = ({ label, info }) => {
  const [visible, setVisible] = useState(false);
  const { guideMode } = useContext(GuideContext);

  const showModal = () => setVisible(true);
  const handleClose = () => setVisible(false);

  return (
    <>
      {guideMode && (
        <button
          type="button"
          className="info-modal-pulse-dot"
          onClick={showModal}
          data-testid="info-modal-button"
          aria-label={label ? `Open info for ${label}` : "Open info"}
        >
          <span className="info-modal-pulse-ring" />
          <span className="info-modal-pulse-core">
            <Info size={8} />
          </span>
        </button>
      )}
      <Modal
        open={visible}
        onCancel={handleClose}
        footer={null}
        centered
        width={320}
        closeIcon={<X size={18} className="info-modal-close-icon" />}
        className="info-modal-modal"
      >
        <div className="info-modal-header">
          <Info className="info-modal-header-icon" />
          <span
            className="info-modal-header-label"
            data-testid="info-modal-header-label"
          >
            {label}
          </span>
        </div>
        <div data-testid="info-modal-info" className="info-modal-info">
          {info}
        </div>
      </Modal>
    </>
  );
};

export default InfoModal;
